<template>
  <section class="header">
    <h1>{{ title }}</h1>
    <template v-if="hasInfo">
      <template v-if="presentInfo">
        <GraphIcon
          class="icon"
          role="button"
          tabindex="0"
          @click="emits('onChange', false)"
          @keydown.enter="emits('onChange', false)"
          @keydown.space="(event: Event) => handleSpaceKey(event, false)"
        />
      </template>
      <template v-else>
        <InfoIcon
          class="icon"
          role="button"
          tabindex="0"
          @click="emits('onChange', true)"
          @keydown.enter="emits('onChange', true)"
          @keydown.space="(event: Event) => handleSpaceKey(event, true)"
        />
      </template>
    </template>
  </section>
</template>
<script lang="ts" setup>
import InfoIcon from '@/design-system/assets/icons/IconInfoCircle.vue'
import GraphIcon from '@/design-system/assets/icons/IconTimeLine.vue'
type Props = {
  title: string
  hasInfo: boolean
  presentInfo: boolean
}
type Emits = {
  (e: 'onChange', value: boolean): void
}
defineProps<Props>()
const emits = defineEmits<Emits>()

function handleSpaceKey(event: Event, value: boolean) {
  event.preventDefault() // Prevent space bar scrolling
  emits('onChange', value)
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
section.header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  h1 {
    all: unset;
    @include font-mixins.desktop-bold-label;
    color: variables.$color-greyscale-content;
    display: flex;
    flex-grow: 1;
    white-space: nowrap;
    overflow-x: hidden;
  }
  .icon {
    display: block;
    height: variables.$tooltip-icon-size;
    width: variables.$tooltip-icon-size;
    text-align: center;
    cursor: pointer;
    color: #767676;
    transition: transform 0.15s ease;
    &:focus {
      outline: none;
    }
    &:focus-visible {
      outline: auto;
    }
  }
}
</style>
